<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="8" md="8" class="pb-0">
        <div style="width: 100%; height: 100%;">
          <canvas ref="chart" height="150"></canvas>
        </div>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col
        cols="12"
        sm="3"
        md="3"
        :class="'text-center ' + (showLabels ? 'mt-auto' : '')"
      >
        <div>Score</div>
        <div
          class="text-h1"
          v-bind:style="{
            color: getOpinionScoreColor(totalScore)
          }"
        >
          {{ totalScore | one_decimal }}
        </div>
      </v-col>
    </v-row>
    <v-row v-if="showLabels">
      <v-col cols="12" sm="4" md="4" class="subtitle-1 pt-0">
        {{ scaleLeftLabel }}
      </v-col>
      <v-col cols="12" sm="4" md="4" class="subtitle-1 pt-0 text-right">
        {{ scaleRightLabel }}
      </v-col>
      <v-divider vertical></v-divider>
    </v-row>
  </v-container>
</template>

<script>
import Chart from "chart.js";
import "chartjs-plugin-datalabels";
import questionTypes from "@/helpers/mixins/questionTypes";
export default {
  name: "SurveyOpinionScaleResults",
  mixins: [questionTypes],
  props: {
    answers: { type: Array },
    scaleRightLabel: { type: String },
    scaleLeftLabel: { type: String }
  },
  data: () => ({ chart: null, questionTypes: questionTypes }),
  watch: {
    answers() {
      this.loadChart();
    }
  },
  computed: {
    showLabels() {
      return this.scaleRightLabel || this.scaleLeftLabel;
    },
    totalScore() {
      let count = this._.sumBy(this.answers, "count");
      if (count == 0) {
        return 0;
      }
      let total = 0;
      this.answers.forEach(value => {
        total += value.value * value.count;
      });
      return parseFloat(total) / parseFloat(count);
    },
    labels() {
      return this._.range(0, 11);
    },
    datasets() {
      let self = this;
      return [
        {
          data: this._.range(0, 11).map(current => {
            let answer = this.answers.find(x => x.value == current);
            if (answer) {
              return answer.count;
            }
            return 0.1;
          }),
          backgroundColor: this._.range(0, 11).map(current => {
            return self.getOpinionScoreColor(current);
          })
        }
      ];
    }
  },
  mounted() {
    this.loadChart();
  },
  methods: {
    loadChart() {
      let self = this;
      Chart.defaults.global.defaultFontColor = this.$vuetify.theme.themes.light.secondarytext;
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new Chart(this.$refs.chart, {
        type: "bar",
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: {
          onClick: function(e) {
            if (self.isAnonymous) {
              return;
            }
            let activePoints = this.chart.getElementsAtEvent(e);
            let idx = activePoints[0]["_index"];
            let answer = self.answers.find(x => x.value == idx);
            self.$emit("answer", answer);
          },
          hover: { mode: null },
          legend: { display: false },
          tooltips: {
            enabled: false
          },
          scales: {
            yAxes: [
              {
                ticks: { min: 0, maxTicksLimit: 3, padding: 8 },
                gridLines: {
                  display: true,
                  drawTicks: false,
                  drawOnChartArea: false
                }
              }
            ],
            xAxes: [
              {
                ticks: { padding: 4 },
                gridLines: {
                  display: true,
                  drawTicks: false,
                  drawOnChartArea: false
                }
              }
            ]
          },
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  }
};
</script>
